import {createSlice} from '@reduxjs/toolkit';
import {VAT} from '../../../../utils';

const initialPopupEditRowDataState = {
  dataLoading: false,
  entities: {
    address: '',
    canCreate: false,
    contact: '',
    createdAt: '',
    customerID: '',
    customerName: '',
    emailRecipients: '',
    idNumber: 0,
    lines: [],
    phone: '',
    status: 0,
    statusText: '',
    totalAmount: 0,
    userId: '',
    vat: VAT.percents(new Date()),
    _id: '',
  },
  error: null,
};
export const callTypes = {
  data: 'data',
  action: 'action'
};

export const popupEditRowDataSlice = createSlice({
  name: 'popupEditRowData',
  initialState: initialPopupEditRowDataState,
  reducers: {
    popupEditRowDataFetched: (state, action) => {
      const {entities} = action.payload;
      state.dataLoading = false;
      state.error = null;
      state.entities = entities;
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.invoiceOrdersError = null;
      if (action.payload.callType === callTypes.data) {
        state.dataLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
  }
});
